export default __webpack_public_path__ + "static/media/Vazir-Black.18bc4ee7.ttf";